    <div class="machine-card-wrapper">
      <ion-header>
        <ion-toolbar color="light">
          <ion-title>Machine List</ion-title>
        </ion-toolbar>
      </ion-header>
      <div id="machine-list-card">
        <ion-list *ngFor="let machine of machineList" [style.background-color]="machine.color">
          <ion-row class="ion-align-items-start">
            <ion-col size="auto">
              <ion-icon style="color: #000;" name="machine.icon"></ion-icon>
            </ion-col>
            <ion-col style="color: #000;">
                <ion-row class="ion-text-start ion-text-wrap" (click)="onSelectMachine(machine.id)">{{machine.name}}</ion-row>
                <ion-row class="ion-text-start ion-text-wrap" *ngIf="machine.name">{{machine.make}} {{machine.model}}</ion-row>
              </ion-col>
            </ion-row>
        </ion-list>
        <ion-footer></ion-footer>
      </div>
    </div>
